import UserProfileGrid from "../../components/user_profile/ProfileCardGrid";
import Box from '@mui/material/Box';

export const FullRosterDash = () => {
    return (
        <Box sx={{
            padding: '1em',
        
        }}>
            <h1>User Roster Dash </h1>
            <UserProfileGrid />
        </Box>
    );
}